import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const PrimaryButtonWithStyles = styled(Button)`
  &:hover {
    opacity: 0.9;
    background-color: ${(props) => props.theme.palette.primary.main};
  }

  &:disabled {
    opacity: 0.4;
    background-color: ${(props) => props.theme.palette.primary.main};
    color: ${(props) => props.theme.palette.primary.contrastText};
  }
`;

const PrimaryButton = (props) => {
  return (
    <PrimaryButtonWithStyles
      color="primary"
      variant="contained"
      disableElevation
      // disableRipple
      {...props}
    />
  );
};

export default PrimaryButton;
